import { shallowEqual, useSelector } from 'react-redux'

export default function usePrivileges() {
	const privileges = useSelector(state => state.auth.account?.privileges, shallowEqual)

	const userHasPrivilegeFor = (privilege) => {
		return privileges ? privileges.includes(privilege) : false
	}

	return {
		userHasPrivilegeFor
	}
}
